import { type FC, useState } from "react";
import { QuickLink } from "./QuickLink";

interface ModalProps {
  isModalOpen: boolean;
  handleClose: () => void;
  quickLink: boolean;
}
interface Props {
  Modal: FC<ModalProps>;
  title: string;
  text: string;
}
export const QuickLinkComponent = ({ Modal, title, text }: Props) => {
  const [isAddTeamOpen, setIsAddTeamOpen] = useState(false);

  return (
    <>
      <QuickLink
        title={title}
        text={text}
        handleClick={() => {
          setIsAddTeamOpen(true);
        }}
      />
      <Modal
        quickLink={true}
        isModalOpen={isAddTeamOpen}
        handleClose={() => {
          setIsAddTeamOpen(false);
        }}
      />
    </>
  );
};
